import React from 'react';
import { Collapse } from 'antd';
import FootBathItem from './FootBathItem';
import MultiInputGroup from '../../components/media/MultiInputGroup';
import HerbItem from './HerbItem';
import MeditationItem from './MeditationItem';
import ExerciseItem from './ExerciseItem';
import OrderedMedia from '../../components/media/OrderedMedia';

const { Panel } = Collapse;
const DynamicConfigPanel: React.FC<any> = ({ form, dataType, prefix }) => {
    // 根据不同的数据类型渲染不同的配置项
    const renderConfigItems = () => {
        switch (dataType) {
            case 'FOOT_BATH':
                return <FootBathItem form={form} prefix={prefix} fullPrefix={prefix} />;
            case 'HERB':
                return (
                    <MultiInputGroup
                        type={dataType} name={[...prefix, "defaultList"]} addable removable divider
                        item={(index: any) => <OrderedMedia index={index} form={form} listPathName={[...prefix, "defaultList"]}>
                            <HerbItem prefix={[index]} fullPrefix={[...prefix, "defaultList", index]} />
                        </OrderedMedia>}
                    />
                );
            case 'ACUPOINT_MASSAGE':
                return (
                    <MultiInputGroup
                        type={dataType} name={[...prefix, "defaultList"]} addable removable divider
                        item={(index: any) => <OrderedMedia index={index} form={form} listPathName={[...prefix, "defaultList"]}>
                            <HerbItem prefix={[index]} fullPrefix={[...prefix, "defaultList", index]} />
                        </OrderedMedia>}
                    />
                );
            case 'MEDITATION':
                return (
                    <MultiInputGroup
                        type={dataType} name={[...prefix, "defaultList"]} addable removable divider
                        item={(index: any) => <OrderedMedia index={index} form={form} listPathName={[...prefix, "defaultList"]}>
                            <MeditationItem form={form} prefix={[index]} fullPrefix={[...prefix, "defaultList", index]} />
                        </OrderedMedia>}
                    />
                );
            case 'EXERCISE':
                return (
                    <div>
                        <MultiInputGroup
                            type={dataType} name={[...prefix, "defaultList"]} addable removable divider
                            item={(index: any) => <OrderedMedia index={index} form={form} listPathName={[...prefix, "defaultList"]}>
                                <ExerciseItem form={form} prefix={[index]} fullPrefix={[...prefix, "defaultList", index]} dataType={dataType} />
                            </OrderedMedia>}
                        />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <Collapse defaultActiveKey={['1']} style={{ marginRight: 30 }}>
            <Panel key="1" header="配置信息">
                {renderConfigItems()}
            </Panel>
        </Collapse>
    );
};

export default DynamicConfigPanel;